import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Components
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Testimonials } from "./components/Testimonials";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

// Pages
import CelularPage from "./pages/CelularPage";
import NotebookPage from "./pages/NotebookPage";
import SmartwatchPage from "./pages/SmartwatchPage";
import ComputadorPage from "./pages/ComputadorPage";
import WebDesignPage from "./pages/WebDesignPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Home Page
const HomePage = () => {
  return (
    <>
      <Hero />
      <Services />
      <About />
      <Testimonials />
      <FAQ />
      <Contact />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/celular" element={<CelularPage />} />
            <Route path="/notebook" element={<NotebookPage />} />
            <Route path="/smartwatch" element={<SmartwatchPage />} />
            <Route path="/computador" element={<ComputadorPage />} />
            <Route path="/webdesign" element={<WebDesignPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
